import React, { useCallback } from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { CustomerCreate, CustomerDeleteModal, CustomerList, CustomerUpdate } from '@app/features/Customer';
import { useResourceScreenHelpers } from '@app/hooks';
import { customerApi } from '@app/store';
import { CustomerHeader } from '@app/features/CustomerHeader';
import { ICustomer } from '@app/common';
import { CheckPermissions } from '@app/components/CheckPermissions';
import { RouteProp, useFocusEffect, useRoute } from '@react-navigation/native';
import { RootStackParamList } from '@app/types';

export const CustomerScreen = () => {
  const route = useRoute<RouteProp<RootStackParamList, 'CustomerScreen'>>();

  const [readOne, { isFetching }] = customerApi.useLazyReadOneCustomersQuery();
  const [deleteOne, { isLoading }] = customerApi.useDeleteOneCustomersMutation();

  const { triptych, modal, onDelete, onUpdate, mode, selectedItem, item: customer } = useResourceScreenHelpers<ICustomer>();

  const openCard = (item: Partial<ICustomer>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item?._id } },
    }), item)
  }

  useFocusEffect(
    useCallback(() => {
      if (Boolean(route.params?._id)) {
        openCard({ _id: route.params._id, firstname: "Chargement..." });
      }
    }, [route])
  );

  return (
    <MainLayout
      header={(
        <CustomerHeader>
          <CheckPermissions permissions={['dashboard::customers.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter un client' />
          </CheckPermissions>
        </CustomerHeader>
      )}>

      <CustomerDeleteModal
        {...modal}
        onDelete={(customer) => onDelete(deleteOne(customer._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <CustomerList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open} />
        )}
        form={(
          mode === 'CREATE'
            ? <CustomerCreate />
            : <CustomerUpdate
              customer={customer ?? selectedItem}
              isFetching={isFetching}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              onDelete={modal.open} />
        )} />
    </MainLayout>
  );
}; 